const getRegisteredGroups = (rootState) => rootState.ui.contextMenu.registeredGroups;

export default getRegisteredGroups;
